// extracted by mini-css-extract-plugin
module.exports = {"qaSection":"faq_qaSection__2nY4w","activeLanguage":"faq_activeLanguage___zkDi","qa":"faq_qa__dROpy","question":"faq_question__1cKxr","answer":"faq_answer__3jhOv"};